import type { CostConstraintAdjustment } from "@erp/shared-types";
import { serializeMoney, tryParseMoney } from "./money";

/** A receive cost between the two prices, at the PO unit-cost precision. */
export function costConstraintCost(
  systemCost: string | number | null,
  poCost: string | number | null,
  adjustment: CostConstraintAdjustment = {
    kind: "savings_percent",
    value: "50",
  },
): string | null {
  const system = tryParseMoney(systemCost);
  const po = tryParseMoney(poCost);
  const value = tryParseMoney(adjustment.value);
  if (
    !system ||
    !po ||
    !value ||
    system.isNegative() ||
    po.isNegative() ||
    value.isNegative()
  )
    return null;
  if (adjustment.kind === "savings_percent" && value.greaterThan(100))
    return null;
  if (adjustment.kind === "amount" && value.decimalPlaces() > 4) return null;
  const cost =
    adjustment.kind === "amount"
      ? value
      : po.plus(system.minus(po).times(value).dividedBy(100));
  const rounded = serializeMoney(cost, 4);
  const lower = system.lessThan(po) ? system : po;
  const upper = system.greaterThan(po) ? system : po;
  return lower.lessThanOrEqualTo(rounded) && upper.greaterThanOrEqualTo(rounded)
    ? rounded
    : null;
}
